module.exports = __webpack_public_path__ + "d88c812433fa571b8d952dc2810485e8.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2018-04-12/whats-new.html
// module id = 1909
// module chunks = 0